import React, { Component } from "react";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import axios from "axios";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { NewInputText } from "../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { ButtonReusableComponent } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { SliderReusableComponent } from "../../reusableComponents/sliderReusableComponent/SliderReusableComponent";

import {
  LoginTopLogoAndText,
  BackLogoIconButton,
} from "../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import InputNumberFunc from "../../../function/InputNumberFunc";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import { forgot_sendotp } from "../../../store/actions/authAction";
import { MobileNumberValidation } from "../../../store/validation/allValidationFile/authenticationValidation/MobileNumberValidation";
import isEmpty from "../../../store/validation/is-Empty";

export class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      country_code: "",
      number: "",
      errors: {},
      error: null,
      isLoading: false,
      loading: false,
    };
  }

  componentDidMount() {
    if (
      this.props.auth.forgotNumber !== undefined &&
      this.props.auth.forgotNumber !== null
    ) {
      this.setState({
        number: !isEmpty(this.props.auth.forgotNumber)
          ? this.props.auth.forgotNumber
          : "",
      });
    }
    this.setState({ isLoading: true });
    axios
      .get("https://ipapi.co/json")
      .then((result) =>
        this.setState({
          country_code: result.data.country_calling_code,
          isLoading: false,
        })
      )
      .catch((error) =>
        this.setState({
          error,
          isLoading: false,
        })
      );
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      Object.keys(nextProps.errors).length > 0 &&
      nextProps.errors !== nextState.errors
    ) {
      return {
        errors: nextProps.errors,
      };
    }
    if (nextProps.auth.loader !== nextState.loading) {
      return {
        loading: nextProps.auth.loader,
      };
    }
    return null;
  }

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  handleOnChange = (value) => {
    this.setState({ country_code: "+" + value, errors: {} });
  };

  onChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      errors: {},
    });
    this.props.clear_all_errors();
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
    });
  };

  /******************************
   * @DESC - ON SUBMIT HANDLER
   *****************************/
  handleSubmit = (e) => {
    e.preventDefault();
    const { errors, isValid } = MobileNumberValidation(this.state);
    if (!isValid) {
      this.setState({
        errors: errors,
      });
    } else {
      const formData = {
        mobile_number: this.state.number,
        country_code: this.state.country_code,
        strategy: "vendor-user",
        forgot_password: true,
      };
      this.props.forgot_sendotp(formData, this.props.history);
    }
  };

  render() {
    const { number, errors, loading } = this.state;

    if (loading) {
      return (
        <React.Fragment>
          <AmealioLoader />
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <Container fluid className="loginsignup-main">
          <Row>
            {/* <BackButtonIcon linkPath="/" /> */}
            <Col className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 loginsignup-leftside">
              <div className="col-12 display-top-header-mobile">
                <BackLogoIconButton
                  displayHelpImage={true}
                  displayArrow={true}
                  displayBackText="Back"
                  backButtonClicked="/"
                  notDisplaProgressBar={true}
                />
              </div>
              <div className="col-12 loginsignup-section">
                <LoginTopLogoAndText
                  bigText="Forget Password"
                  smallText="Please enter your registered phone number to receive OTP to reset your password"
                />
              </div>
              <Col className="login-section-margin">
                <Form noValidate>
                  <Form.Row className="input-component-insideRow">
                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 pr-0">
                      <Form.Group
                        className="reusableInputComponent-main mb-0"
                        controlId={"country_code"}
                      >
                        <div className="input-phone-country-code-reusable">
                          {/* <select
                            name="country_code"
                            value={this.state.country_code}
                            onChange={this.onChange}
                          >
                            <option value={this.state.country_code}>
                              {this.state.country_code}
                            </option>
                            {getCountries().map((country) => (
                              <option
                                key={country}
                                value={"+" + getCountryCallingCode(country)}
                              >
                                {en[country]} (+{getCountryCallingCode(country)}
                                )
                              </option>
                            ))}
                          </select> */}
                          <select
                            className="w-100"
                            name="country_code"
                            value={this.state.country_code}
                            onChange={this.onChange}
                          >
                            <option value={this.state.country_code}>
                              {this.state.country_code}
                            </option>
                            {getCountries().map(
                              (country) => (
                                // this.state.country_code !==
                                // "+" + getCountryCallingCode(country) && (
                                <option
                                  key={country}
                                  value={"+" + getCountryCallingCode(country)}
                                >
                                  {en[country]} (+
                                  {getCountryCallingCode(country)})
                                </option>
                              )
                              // )
                            )}
                          </select>
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 pl-0">
                      <NewInputText
                        extraClass="mb-0"
                        name="number"
                        inputType="number"
                        onFocusOut={this.onFocusOut}
                        onChange={this.onChange}
                        onKeyDown={InputNumberFunc}
                        value={this.state.number}
                        maxLength="10"
                        errorText={
                          this.state.number.length > 0 &&
                          this.state.number.length <= 9
                            ? "Enter valid Mobile Number"
                            : null || errors.number === "number is required"
                            ? "mobile number is required"
                            : null || errors.code === 400
                            ? "Invalid Account"
                            : null
                        }
                        errorTrue={
                          (this.state.number.length > 0 &&
                            this.state.number.length <= 9) ||
                          errors.number === "number is required" ||
                          errors.code === 400
                            ? true
                            : false
                        }
                        labelText="Phone Number"
                        controlClass={
                          (this.state.number.length > 0 &&
                            this.state.number.length <= 9) ||
                          errors.number === "number is required" ||
                          errors.code === 400
                            ? "outlined-error-helper-text"
                            : "outlined-helperText"
                        }
                      />
                    </div>
                    <div className="col-11 send-otp-message-text">
                      *OTP will be sent to your registered phone number and
                      e-mail address. It is valid for 10 minutes.
                    </div>
                  </Form.Row>
                </Form>
                <Col className="p-0">
                  <ButtonReusableComponent
                    buttonText="Get OTP"
                    buttonType="submit"
                    buttonClass={number.length <= 9 ? "login" : "activeLogin"}
                    disabled={number.length <= 9 ? true : false}
                    onClick={this.handleSubmit}
                  />
                </Col>
              </Col>
            </Col>
            <Col className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={
                  require("../../../assets/images/illustratorImage/Amealio_Illustrations-09.png")
                    .default
                }
              />
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

ForgotPassword.propTypes = {
  forgot_sendotp: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  forgot_sendotp,
  clear_all_errors,
})(withRouter(ForgotPassword));
